import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#fff',
    border: `1px solid ${theme.palette.primary.main}`,
    padding: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}))

export default useStyles
